import { TransactionReportViewModel } from "@payping/api";
import { CLEAR_LIST, LOGGED_OUT } from "./constants";
import { ClearListAction, LoggedOutAction } from "./types";
import { TransactionDetailsVM } from "../actions";

export const REQUEST_MONEYS_LOADED = "REQUEST_MONEYS_LOADED";
export const SET_REQUEST_MONEY_DETAILS = "SET_REQUEST_MONEY_DETAILS";

export interface RequestMoneyState {
  list: TransactionReportViewModel[];
  totalCount: number;
  paginationEnd: boolean;
  details?: TransactionDetailsVM;
}

export interface RequestMoneysLoadedAction {
  type: typeof REQUEST_MONEYS_LOADED;
  payload: { list: TransactionReportViewModel[]; totalCount: number; append: boolean };
}

export interface SetRequestMoneyDetailsAction {
  type: typeof SET_REQUEST_MONEY_DETAILS;
  payload: { details?: TransactionDetailsVM };
}

export type RequestMoneyActionTypes =
  | RequestMoneysLoadedAction
  | SetRequestMoneyDetailsAction
  | ClearListAction
  | LoggedOutAction;

const initialState: RequestMoneyState = {
  details: undefined,
  list: [],
  paginationEnd: false,
  totalCount: 0,
};

export default function reports(state = initialState, action: RequestMoneyActionTypes): RequestMoneyState {
  if (action.type === REQUEST_MONEYS_LOADED) {
    const { list, totalCount, append } = action.payload;
    const newList = append ? [...state.list, ...list] : list;
    return {
      ...state,
      list: newList,
      paginationEnd: !list.length || newList.length >= totalCount,
      totalCount,
    };
  }

  if (action.type === SET_REQUEST_MONEY_DETAILS) {
    const { details } = action.payload;
    return {
      ...state,
      details,
    };
  }

  if (action.type === CLEAR_LIST) {
    return {
      ...state,
      list: [],
    };
  }

  if (action.type === LOGGED_OUT) {
    return initialState;
  }

  return state;
}
